<template>
  <div>
    <!-- Modal Component -->
    <b-modal
      id="sign-up-confirm-code-modal"
      title="Confirm Sign-up"
      centered
    >
      <div
        id="forgot-password-input-container"
        class="form-group text-left"
      >
        <label style="margin-bottom: 1rem;">We have sent you a verification code to your email address</label>
        <input
          v-model="confirmation_code"
          class="form-control"
          placeholder="Please enter the verification code"
          :disabled="is_loading"
          type="password"
          required="true"
          autocomplete="off"
          @keyup.enter="clickedSendVerificationCode()"
        >
      </div>
      <div
        slot="modal-footer"
        class="w-100"
      >
        <b-btn
          class="footer-button"
          size="xl"
          variant="primary"
          :disabled="is_loading"
          @click="clickedCheckConfirmationCode()"
        >
          <i
            v-show="is_loading"
            class="fa fa-spinner fa-spin"
          /> Confirm Sign-up
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'

import USER_API from '../../api/user'

import utils from '../../utils.js'

export default {
	props: {
		user: {
			type: Object,
			required: true
		}
	},

	data () {
		return {
			confirmation_code: '',
			is_loading: false
		}
	},

	mounted () {
		// `this` points to the vm instance
		console.debug('Mounted ForgotPasswordComponent', this.user)
		console.debug('Mounted: email: ' + this.email)
	},
	// We watch the props being changed and update the email accordingly
	methods: {
		clickedCheckConfirmationCode: function () {
			console.debug('this.email : ' + this.user.email)

			if (!this.is_loading) {
				if (this.confirmation_code) {
					this.is_loading = true

					const params = {
						email: this.user.email,
						confirmation_code: this.confirmation_code
					}

					const reference = this

					USER_API.check_confirmation_code(params,
						() => {
							reference.$root.$emit('bv::hide::modal', 'sign-up-confirm-code-modal')

							utils.makeToast(reference.$bvToast, 'Success', 'success', 'You are successfully signed-up')

							reference.$emit('confirmed-code', reference.user.email, reference.user.password)

							reference.is_loading = false
						},
						e => {
							console.debug(e)

							reference.is_loading = false

							if (e.hasOwnProperty('response')) {
								const response = e['response']

								if (response != undefined) {
									if (response.hasOwnProperty('data')) {
										const data = response['data']

										if (data.hasOwnProperty('error')) {
											const error = data['error']
											utils.makeToast(reference.$bvToast, 'Error', 'danger', error)

											return
										}
									}
								}
							}

							utils.makeToast(reference.$bvToast, 'Error', 'danger', "A problem occured with the check of your verification code, make sure it's the correct")
						}
					)
				} else {
					console.debug('Invalid email ')

					this.showEmailError = true
				}
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
h1
	color: green

#forgot-password-input-container
	text-align: left

#succm-label
	margin-bottom: 0.5rem
	padding: 0.2rem
</style>
